'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.remoteExportWidget = function (exportController, subscriptionModel) {
	return mmWidgets.each(this, function () {
		const self = this.sectionHandlerWidget(),
			selectedFormat = function () {
				return self.attr('data-mm-format') || self.find('[data-mm-role~=format-selector]').val();
			},
			initialProgressMessage = self.find('[data-mm-role~="publish-progress-message"]').text(),
			confirmElement = self.find('[data-mm-role~="start-export"]'),
			publishResult = function (result = {}) {
				Object.keys(result).forEach((key) => {
					const value = result[key],
						fields = self.find('[data-mm-role~=' + key + ']');
					fields.domElements.forEach(function (domElement) {
						if (domElement.tagName === 'A') {
							domElement.setAttribute('href', value);
						} else if (domElement.tagName === 'INPUT' || domElement.tagName === 'TEXTAREA') {
							domElement.value = value;
							domElement.setAttribute('data-mm-val', value);
						} else if (domElement.tagName === 'DIV') {
							if (domElement.matches(`[data-mm-role~="${value}"]`)) {
								domElement.classList.remove('hidden');
							} else {
								domElement.classList.add('hidden');
							}
						}
					});
				});

				trackEvent({
					action: 'map_published',
				});

				self.trigger('publishResult');
				self.showSection('done');
			},
			publishProgress = function (progress) {
				self.find('[data-mm-role~="publish-progress-message"]').text(progress);
			},
			getExportMetadata = function () {
				const meta = {},
					fields = self.find('[data-mm-export-parameter]');
				fields.domElements.forEach(function (domElement) {
					let value;
					if ('checkbox' === domElement.getAttribute('type')) {
						value = domElement.checked;
					} else {
						value = domElement.value || (!domElement.getAttribute('data-mm-ignore-placeholder') && domElement.getAttribute('placeholder'));
					}
					meta[domElement.getAttribute('data-mm-export-parameter')] = value;
				});
				return meta;
			},
			showError = function (reason) {
				const predefinedMsg = self.find('[data-mm-error~="' + reason + '"]');
				self.find('[data-mm-error]').addClass('hidden');
				if (predefinedMsg.length > 0) {
					predefinedMsg.removeClass('hidden');
				} else {
					self.find('[data-mm-error~="default"]').html(reason).removeClass('hidden');
				}
				self.showSection('error');
			},
			exportFailed = function (error) {
				let reason = (error && error.reason) || error,
					fileId = (error && error.fileId);

				if (!['empty', 'action-not-allowed'].includes(reason) && !fileId) {
					reason = 'network-error';
					fileId = 'NO-FILE-ID';
				}
				if (fileId) {
					self.find('[data-mm-role~="file-id"]').html(fileId);
				}
				showError(reason);
			},
			doExport = function () {
				publishProgress(initialProgressMessage);
				self.showSection('inprogress');
				exportController.startExport(selectedFormat(), {'export': getExportMetadata()}, {notify: publishProgress})
					.then(publishResult, exportFailed);
			};
		confirmElement.click(doExport).on('keydown', function (e) {
			if (e.which === 32 && e.target === confirmElement.domElements[0]) {
				e.preventDefault();
				e.stopPropagation();
				doExport();
			}
		});
		self.on('show', function () {
			if (self.hasSection('initial')) {
				self.showSection('initial');
				self.trigger('shown');
			} else {
				publishProgress('Retrieving your account details...');
				self.showSection('inprogress');

				subscriptionModel.getGoldAccountDetails().then(function (goldAccountDetails) {
					if (goldAccountDetails && goldAccountDetails.active) {
						self.showSection('initial-gold');
					} else {
						self.showSection('initial-free');
					}
				}, function (reason) {
					if (reason === 'not-registered') {
						self.showSection('initial-free');
					} else {
						showError(reason);
					}
				}).then(function () {
					self.trigger('shown');
				});
			}
		});
	});
};
